/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.205.0-v202609260125-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqAnnotationsApiClass {
 
   constructor() {}

  /**
   * @summary Archive an annotation
   * @param {string} id - ID of the annotation to archive
  */
  public archiveAnnotation(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/annotations/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @param {string} imageUrl
   * @param {string} [accept]
  */
  public corsImageProxy(
    {
      imageUrl,
      accept
    } : {
      imageUrl: string,
      accept?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (imageUrl === null || imageUrl === undefined) {
      throw new Error("'imageUrl' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations/image/cors/${encodeURIComponent(String(imageUrl))}`
      .replace('{imageUrl}', encodeURIComponent(String(imageUrl)));
    const urlTemplate = `${baseUrl}/annotations/image/cors/{imageUrl}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      headers: {
        ['Accept']: accept as string
      },
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Create an annotation
  */
  public createAnnotation(
    body: models.AnnotationInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations`;
    const urlTemplate = `${baseUrl}/annotations`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AnnotationOutputV1>;
  }

  /**
   * @summary Delete an image from a journal entry
   * @param {string} id - The ID of the Annotation that uses the image
   * @param {string} fileName - The file name of the image
  */
  public deleteImage(
    {
      id,
      fileName
    } : {
      id: string,
      fileName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (fileName === null || fileName === undefined) {
      throw new Error("'fileName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations/${encodeURIComponent(String(id))}/images/${encodeURIComponent(String(fileName))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{fileName}', encodeURIComponent(String(fileName)));
    const urlTemplate = `${baseUrl}/annotations/{id}/images/{fileName}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Get an annotation
   * @param {string} id - ID of the annotation to retrieve
  */
  public getAnnotation(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/annotations/{id}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.AnnotationOutputV1>;
  }

  /**
   * @summary Get a collection of annotations
   * @param {Array<string>} [annotates] - A list of item IDs that will filter the annotations returned to only those that annotate the specified items.
   * @param {string} [type] - The type of annotations to return, either Report or Journal
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getAnnotations(
    {
      annotates,
      type,
      offset,
      limit
    } : {
      annotates?: Array<string>,
      type?: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations`;
    const urlTemplate = `${baseUrl}/annotations`;

    const queryParams = {
      ['annotates']: annotates,      ['type']: type,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.AnnotationListOutputV1>;
  }

  /**
   * @summary Get an image for a journal entry
   * @param {string} id - The ID of the Annotation that uses the image
   * @param {string} fileName - The file name of the image
  */
  public getImage(
    {
      id,
      fileName
    } : {
      id: string,
      fileName: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (fileName === null || fileName === undefined) {
      throw new Error("'fileName' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations/${encodeURIComponent(String(id))}/images/${encodeURIComponent(String(fileName))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{fileName}', encodeURIComponent(String(fileName)));
    const urlTemplate = `${baseUrl}/annotations/{id}/images/{fileName}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Mark the annotation as upgraded to CK Editor using the provided HTML
   * @param {string} id - The Seeq ID for the report
  */
  public migrateAnnotationToCkEditor(
    body: models.MigrateEditorInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations/editorMigration/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/annotations/editorMigration/{id}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Publish a report so it cannot be changed
   * @param {string} id - ID of the report to publish
  */
  public publishReport(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations/${encodeURIComponent(String(id))}/publish`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/annotations/{id}/publish`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.AnnotationOutputV1>;
  }

  /**
   * @summary Update an annotation
   * @param {string} id - ID of the annotation to update
  */
  public updateAnnotation(
    body: models.AnnotationInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations/${encodeURIComponent(String(id))}/update`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/annotations/{id}/update`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AnnotationOutputV1>;
  }

  /**
   * @summary Upload an image for a journal entry
   * @param {string} id - The ID of the Annotation that will use the image
   * @param {Blob} [file]
  */
  public uploadImage(
    {
      id,
      file
    } : {
      id: string,
      file?: File
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/annotations/${encodeURIComponent(String(id))}/images`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/annotations/{id}/images`;


    const formData = new FormData();
    formData.append('file', file as File, file?.name);

    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      ...restOverrides
    }) as AxiosPromise<models.AnnotationImageLinkOutputV1>;

  }

}


export const sqAnnotationsApi = new sqAnnotationsApiClass();

export type sqAnnotationsApiEndpoints = {
  'archiveAnnotation': {
    method: 'delete';
    path: '/annotations/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'corsImageProxy': {
    method: 'get';
    path: '/annotations/image/cors/${encodeURIComponent(String(imageUrl))}';
    response: string;
  };
  'createAnnotation': {
    method: 'post';
    path: '/annotations';
    response: models.AnnotationOutputV1;
  };
  'deleteImage': {
    method: 'delete';
    path: '/annotations/${encodeURIComponent(String(id))}/images/${encodeURIComponent(String(fileName))}';
    response: models.StatusMessageBase;
  };
  'getAnnotation': {
    method: 'get';
    path: '/annotations/${encodeURIComponent(String(id))}';
    response: models.AnnotationOutputV1;
  };
  'getAnnotations': {
    method: 'get';
    path: '/annotations';
    response: models.AnnotationListOutputV1;
  };
  'getImage': {
    method: 'get';
    path: '/annotations/${encodeURIComponent(String(id))}/images/${encodeURIComponent(String(fileName))}';
    response: string;
  };
  'migrateAnnotationToCkEditor': {
    method: 'post';
    path: '/annotations/editorMigration/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'publishReport': {
    method: 'post';
    path: '/annotations/${encodeURIComponent(String(id))}/publish';
    response: models.AnnotationOutputV1;
  };
  'updateAnnotation': {
    method: 'post';
    path: '/annotations/${encodeURIComponent(String(id))}/update';
    response: models.AnnotationOutputV1;
  };
  'uploadImage': {
    method: 'post';
    path: '/annotations/${encodeURIComponent(String(id))}/images';
    response: models.AnnotationImageLinkOutputV1;
  };
};

type ApiArchiveAnnotationResponse = models.StatusMessageBase;
type ApiarchiveAnnotationMutationParams = Parameters<typeof sqAnnotationsApi.archiveAnnotation> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAnnotationsApi.archiveAnnotation>;

export function useApiArchiveAnnotationMutation(
  options?: Omit<UseMutationOptions<ApiArchiveAnnotationResponse, AxiosError<SeeqErrorData>,
    ApiarchiveAnnotationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveAnnotationResponse, AxiosError<SeeqErrorData>,
  ApiarchiveAnnotationMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveAnnotationMutationParams) =>
      sqAnnotationsApi.archiveAnnotation(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCorsImageProxyResponse = string;
export function CorsImageProxyQueryKey(
  params: Parameters<typeof sqAnnotationsApi.corsImageProxy>[0],
) {
  return ['sqAnnotationsApi', 'corsImageProxy', params] as const;
}

export function useApiCorsImageProxyQuery(
  params: Parameters<typeof sqAnnotationsApi.corsImageProxy>[0],
  options?: Omit<UseQueryOptions<ApiCorsImageProxyResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiCorsImageProxyResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: CorsImageProxyQueryKey(params),
    queryFn: () =>
      sqAnnotationsApi.corsImageProxy(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiCreateAnnotationResponse = models.AnnotationOutputV1;
type ApicreateAnnotationMutationParams = Parameters<typeof sqAnnotationsApi.createAnnotation> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAnnotationsApi.createAnnotation>;
type ApicreateAnnotationMutationVariables = models.AnnotationInputV1;

export function useApiCreateAnnotationMutation(
  options?: Omit<UseMutationOptions<ApiCreateAnnotationResponse, AxiosError<SeeqErrorData>,
    ApicreateAnnotationMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateAnnotationResponse, AxiosError<SeeqErrorData>,
  ApicreateAnnotationMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateAnnotationMutationVariables) =>
      sqAnnotationsApi.createAnnotation(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteImageResponse = models.StatusMessageBase;
type ApideleteImageMutationParams = Parameters<typeof sqAnnotationsApi.deleteImage> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAnnotationsApi.deleteImage>;

export function useApiDeleteImageMutation(
  options?: Omit<UseMutationOptions<ApiDeleteImageResponse, AxiosError<SeeqErrorData>,
    ApideleteImageMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteImageResponse, AxiosError<SeeqErrorData>,
  ApideleteImageMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteImageMutationParams) =>
      sqAnnotationsApi.deleteImage(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetAnnotationResponse = models.AnnotationOutputV1;
export function GetAnnotationQueryKey(
  params: Parameters<typeof sqAnnotationsApi.getAnnotation>[0],
) {
  return ['sqAnnotationsApi', 'getAnnotation', params] as const;
}

export function useApiGetAnnotationQuery(
  params: Parameters<typeof sqAnnotationsApi.getAnnotation>[0],
  options?: Omit<UseQueryOptions<ApiGetAnnotationResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAnnotationResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAnnotationQueryKey(params),
    queryFn: () =>
      sqAnnotationsApi.getAnnotation(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAnnotationsResponse = models.AnnotationListOutputV1;
export function GetAnnotationsQueryKey(
  params: Parameters<typeof sqAnnotationsApi.getAnnotations>[0],
) {
  return ['sqAnnotationsApi', 'getAnnotations', params] as const;
}

export function useApiGetAnnotationsQuery(
  params: Parameters<typeof sqAnnotationsApi.getAnnotations>[0],
  options?: Omit<UseQueryOptions<ApiGetAnnotationsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAnnotationsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAnnotationsQueryKey(params),
    queryFn: () =>
      sqAnnotationsApi.getAnnotations(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetImageResponse = string;
export function GetImageQueryKey(
  params: Parameters<typeof sqAnnotationsApi.getImage>[0],
) {
  return ['sqAnnotationsApi', 'getImage', params] as const;
}

export function useApiGetImageQuery(
  params: Parameters<typeof sqAnnotationsApi.getImage>[0],
  options?: Omit<UseQueryOptions<ApiGetImageResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetImageResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetImageQueryKey(params),
    queryFn: () =>
      sqAnnotationsApi.getImage(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiMigrateAnnotationToCkEditorResponse = models.StatusMessageBase;
type ApimigrateAnnotationToCkEditorMutationParams = Parameters<typeof sqAnnotationsApi.migrateAnnotationToCkEditor> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAnnotationsApi.migrateAnnotationToCkEditor>;

export function useApiMigrateAnnotationToCkEditorMutation(
  options?: Omit<UseMutationOptions<ApiMigrateAnnotationToCkEditorResponse, AxiosError<SeeqErrorData>,
    ApimigrateAnnotationToCkEditorMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiMigrateAnnotationToCkEditorResponse, AxiosError<SeeqErrorData>,
  ApimigrateAnnotationToCkEditorMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApimigrateAnnotationToCkEditorMutationParams) =>
      sqAnnotationsApi.migrateAnnotationToCkEditor(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiPublishReportResponse = models.AnnotationOutputV1;
type ApipublishReportMutationParams = Parameters<typeof sqAnnotationsApi.publishReport> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAnnotationsApi.publishReport>;

export function useApiPublishReportMutation(
  options?: Omit<UseMutationOptions<ApiPublishReportResponse, AxiosError<SeeqErrorData>,
    ApipublishReportMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiPublishReportResponse, AxiosError<SeeqErrorData>,
  ApipublishReportMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApipublishReportMutationParams) =>
      sqAnnotationsApi.publishReport(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateAnnotationResponse = models.AnnotationOutputV1;
type ApiupdateAnnotationMutationParams = Parameters<typeof sqAnnotationsApi.updateAnnotation> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAnnotationsApi.updateAnnotation>;

export function useApiUpdateAnnotationMutation(
  options?: Omit<UseMutationOptions<ApiUpdateAnnotationResponse, AxiosError<SeeqErrorData>,
    ApiupdateAnnotationMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateAnnotationResponse, AxiosError<SeeqErrorData>,
  ApiupdateAnnotationMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateAnnotationMutationParams) =>
      sqAnnotationsApi.updateAnnotation(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUploadImageResponse = models.AnnotationImageLinkOutputV1;
type ApiuploadImageMutationParams = Parameters<typeof sqAnnotationsApi.uploadImage> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqAnnotationsApi.uploadImage>;

export function useApiUploadImageMutation(
  options?: Omit<UseMutationOptions<ApiUploadImageResponse, AxiosError<SeeqErrorData>,
    ApiuploadImageMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUploadImageResponse, AxiosError<SeeqErrorData>,
  ApiuploadImageMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiuploadImageMutationParams) =>
      sqAnnotationsApi.uploadImage(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
